export class CreateFabricTableShortcutDemoResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<CreateFabricTableShortcutDemoResponseResultsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateFabricTableShortcutDemoResponse.attributeTypeMap;
    }
    constructor() {
    }
}
